import { render, staticRenderFns } from "./EditContingentModal.vue?vue&type=template&id=4f5bf97a&"
import script from "./EditContingentModal.vue?vue&type=script&lang=js&"
export * from "./EditContingentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports